export default "__VITE_ASSET__CKZuyxPU__"